import { render, staticRenderFns } from "./BaseEtymVarDetails.vue?vue&type=template&id=bdfd67ba&scoped=true&"
import script from "./BaseEtymVarDetails.vue?vue&type=script&lang=js&"
export * from "./BaseEtymVarDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaseEtymVarDetails.vue?vue&type=style&index=0&id=bdfd67ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfd67ba",
  null
  
)

export default component.exports